import { Alert, Box } from '@mui/material';
import { Payments } from '@mui/icons-material';

import {
  CustomButton,
  DrawerForm,
  DrawerFormActionSummary,
  DrawerFormActions,
  DrawerFormSidebar,
} from '../../../common/components';
import useCreatePaymentOrderDialogController from '../hooks/useCreatePaymentOrderDialogController';
import CreatePaymentOrderActiveSection from './payment-order/CreatePaymentOrderActiveSection';

const CreatePaymentOrderDialog = ({
  open,
  onClose,
  invoices,
  providerMap,
}) => {
  const controller = useCreatePaymentOrderDialogController({
    invoices,
    onClose,
    open,
    providerMap,
  });

  return (
    <DrawerForm
      open={open}
      onClose={onClose}
      title="Generar orden de pago"
      width={{ xs: '100vw', md: 'min(1000px, calc(100vw - 40px))' }}
      sidebar={(
        <DrawerFormSidebar
          sections={controller.paymentOrderSections}
          activeSection={controller.activeSection}
          onSelect={controller.setActiveSection}
        />
      )}
      footer={(
        <DrawerFormActions
          summary={(
            <DrawerFormActionSummary
              label={controller.footerTotalLabel}
              value={controller.footerTotalValue}
            />
          )}
        >
          <CustomButton variant="outlined" onClick={onClose}>
            {controller.allProvidersDone ? 'Cerrar' : 'Cancelar'}
          </CustomButton>
          <CustomButton
            variant="base"
            startIcon={<Payments />}
            onClick={controller.submit}
            isLoading={controller.createOrder.isPending}
            disabled={
              !invoices.length
              || controller.total <= 0
              || controller.hasInvalidApplications
              || controller.allProvidersDone
            }
          >
            {controller.allProvidersDone ? 'Generado' : (controller.providerWorkItems.length > 1 ? 'Generar OPs' : 'Generar')}
          </CustomButton>
        </DrawerFormActions>
      )}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 1.25 }, minWidth: 0 }}>
        {controller.error && (
          <Box sx={{ mx: { xs: 1.25, md: 2 } }}>
            <Alert severity="error">{controller.error}</Alert>
          </Box>
        )}
        <CreatePaymentOrderActiveSection controller={controller} />
      </Box>
    </DrawerForm>
  );
};

export default CreatePaymentOrderDialog;
